import lang from '@/lang/middleware/pages/market-analysis';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('description');
  const title = store.$i18n.t('title');
  const jumboTitle = store.$i18n.t('jumbotron.title');
  const subtitle = store.$i18n.t('jumbotron.subtitle');
  store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title: jumboTitle, type: 'expanded' });
  store.commit('pageContent/setHead', { description, title });
};
